/**
 * State used in rendering DrawerHeader
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
